import React from 'react';

export const GenericIntegrationSlots = () => {
  return (
    <>
      <slot name="userSettings" />
    </>
  );
};
